export default "__VITE_ASSET__CqyX5Xr$__"